import { styled } from '@mui/material/styles';

export const ContentArea = styled('div', { label: 'DialogNote' })(({ theme }) => ({
  position: 'relative',
  marginTop: theme.spacing(1),
}));
